'use strict';

var React = require('react');
var IconBase = require('./dist/IconBase.js');

module.exports = function (props) {
    return React.createElement(IconBase, Object.assign({ viewBox: '0 0 1024 1024' }, props, {
        style: { width: '1em' }
    }), React.createElement(
        'g',
        null,
        React.createElement('path', { d: 'M1024 416v-256c0-17.6-14.4-32-32-32h-960c-17.6 0-32 14.4-32 32v256c0 17.6 14.4 32 32 32h120.35l-152.35 448h192l65.292-192h509.414l65.294 192h192l-152.35-448h120.35c17.6 0 32-14.4 32-32zM832 192l-192 192h-192l192-192h192zM256 192h192l-192 192h-192l192-192zM744.944 640h-465.886l65.292-192h335.3l65.294 192zM960 384h-128l128-128v128z' })
    ));
};